/**
 * API Logger for development debugging
 */

interface ApiLog {
  timestamp: string;
  type: "request" | "response" | "error";
  endpoint: string;
  method?: string;
  data?: any;
  status?: number;
  message?: string;
}

class ApiLogger {
  private logs: ApiLog[] = [];
  private maxLogs = 50;

  log(log: Omit<ApiLog, "timestamp">) {
    const entry: ApiLog = {
      ...log,
      timestamp: new Date().toISOString(),
    };

    this.logs.unshift(entry);
    if (this.logs.length > this.maxLogs) {
      this.logs = this.logs.slice(0, this.maxLogs);
    }

    // Console output in development
    if (process.env.NODE_ENV === "development") {
      const style =
        log.type === "error"
          ? "color: red"
          : log.type === "request"
          ? "color: blue"
          : "color: green";

      console.log(
        `%c[API ${log.type.toUpperCase()}] ${log.endpoint}`,
        style,
        log
      );
    }
  }

  logRequest(endpoint: string, method: string, data?: any) {
    this.log({
      type: "request",
      endpoint,
      method,
      data,
    });
  }

  logResponse(endpoint: string, status: number, data?: any) {
    this.log({
      type: "response",
      endpoint,
      status,
      data,
    });
  }

  logError(endpoint: string, message: string, data?: any) {
    this.log({
      type: "error",
      endpoint,
      message,
      data,
    });
  }

  getLogs(): ApiLog[] {
    return this.logs;
  }

  clearLogs() {
    this.logs = [];
  }
}

const apiLogger = new ApiLogger();
export default apiLogger;
